import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Line } from "rc-progress";
import { Fade } from "react-awesome-reveal";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { onMessage } from "firebase/messaging";
import { messaging } from "../../firebase";
import TestOverlay from "../../assets/images/TestOverlay.svg";
import Logo from "../../assets/images/Bodybon-Logo.png";
import { fetchTest } from "../../services/test";

const TestAnalysis = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [fetchRequestFlag, setFetchRequestFlag] = useState(false);
  const [progress, setProgress] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const totalDuration = 20000;

  useEffect(() => {
    const startTime = Date.now();
    const updateProgress = () => {
      const elapsedTime = Date.now() - startTime;
      const currentProgress = Math.min((elapsedTime / totalDuration) * 80, 100);

      setProgress(currentProgress);
      setPercentage(Math.round(currentProgress));

      if (currentProgress >= 100) {
      } else {
        const randomDelay = Math.random() * (500 - 100) + 100;
        setTimeout(updateProgress, randomDelay);
      }
    };

    updateProgress();

    //@ts-ignore
    return () => clearTimeout();
  }, [navigate]);

  // useEffect(() => {
  //   onMessage(messaging, (payload: any) => {
  //     if (payload) {
  //       navigateHandler(payload.data?.extraData);
  //     }
  //   });
  // }, []);

  useEffect(() => {
    if (progress >= 95 && progress <= 97 && !fetchRequestFlag) {
      setFetchRequestFlag(true);
      const fetchData = async () => {
        try {
          const response = await fetchTest(id ?? "");

          if (
            response.data.state !== "read_image" &&
            response.data.state !== "get_analysis"
          ) {
            navigate(`/test-result/${id}?step=1`);
          } else {
            setTimeout(fetchData, 2000);
          }
        } catch (error) {
          setTimeout(fetchData, 2000);
        }
      };
      fetchData();
    }
  }, [progress]);

  return (
    <div>
      <div className="fixed top-0 left-0 w-full h-full bg-pr_primary z-[1001] flex flex-col items-center justify-center">
        <img
          alt="آزمایش"
          src={TestOverlay}
          className="absolute left-0 bottom-0 w-full h-full z-0"
        />

        <Fade triggerOnce>
          <div className="z-1 relative">
            <div className="flex items-center lg:items-start justify-between lg:flex-row flex-col-reverse lg:mb-0 mb-12">
              <div className="mb-20 lg:mb-14">
                <h1 className="text-5xl lg:text-6xl font-[900] font-rokh mt-3 lg:text-right text-center text-white">
                  بادی‌بان
                </h1>
                <h2 className="text-2xl lg:text-4xl font-[900] font-rokh mt-3 lg:text-right text-center text-white">
                  در حال تحلیل آزمایش شماست
                </h2>
                {progress > 99 && (
                  <p className="text-lg lg:text-xl font-[700] font-rokh mt-3 lg:text-right text-center text-white">
                    در حال آماده‌سازی آزمایش ...
                  </p>
                )}
              </div>
              <img
                src={Logo}
                alt="بادی‌بان"
                className="lg:w-[130px] w-[70px] mt-2 mb-4 lg:mt-0 lg:mb-0"
              />
            </div>

            <div className="lg:w-8/12 w-full lg:-mr-14 lg:-mb-10 lg:mt-0 -mt-10 mx-auto">
              <DotLottieReact
                src="/assets/lottie/Test_Loading.json"
                loop
                autoplay
              />
            </div>

            <div className="flex flex-col items-end lg:px-0 px-5">
              <div className="flex items-end">
                <h6 className="font-bold text-2xl lg:text-5xl lg:mb-3 text-white">
                  %
                </h6>
                <h5 className="text-6xl lg:text-9xl mr-2 drop-shadow-xl text-white text-left">
                  {percentage}
                </h5>
              </div>
              <div className="w-full">
                <Line
                  percent={progress}
                  strokeWidth={1}
                  strokeColor="#fff"
                  trailColor="rgba(255, 255, 255, 0.4)"
                />
              </div>
            </div>

            <p className="text-center mt-2 text-white text-xs lg:text-base lg:font-[700] font-rokh lg:mx-0 mx-3">
              پس از تحلیل، یک گزارش کامل و دقیق از نتایج آزمایش ارائه می‌شود که
              شامل توضیحات، تشخیص‌ها و توصیه‌های مرتبط است.
            </p>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default TestAnalysis;
